import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress ResizeObserver errors immediately before anything else
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return; // Suppress this specific error
  }
  originalError.apply(console, args);
};

// Also suppress via window error handler
window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop completed')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Import the ResizeObserver fix
import('./utils/resizeObserverFix').then(({ suppressResizeObserverErrors }) => {
  suppressResizeObserverErrors();
});

console.log('Starting WOM Plaza app...');

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

console.log('WOM Plaza app rendered successfully!');